import React, { useContext, useEffect, useState } from "react";
import { get, isEmpty, omit, trim } from "lodash";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import { Field, Formik } from "formik";
import {
  ManagePlanLayout,
  SearchableList,
  DayDropdown,
  DatePicker,
  FieldInput,
  SliderPanel,
  FieldDropSide,
  FieldButtonGroup,
  LoaderWrapper,
} from "../../../components";
import {
  ROUTES,
  MANAGE_PLAN_ROUTES,
  managePlanFormNames,
  formFields,
  FLOW_TYPES,
  getPathWithParam,
  usDateFormat,
  getPlanBasicDetailsHeader,
  yesNoOptions,
  FORM_PLACEHOLDERS,
  getFormattedPhone,
  getAdvancedPathWithParam,
  synchronizeCollection,
  synchronizeCollectionPlanGroups,
} from "../../../utils";
import {
  createPlanStore,
  setManagePlanToastInfo,
  setchangeReviewFlag,
  setPageLevelPlanStatus,
  setPageLevelPlanEffectiveDate,
} from "../../../contexts";
import { useDeepEffect, useRouterParams, useRequest } from "../../../abstracts";
import {
  getBasicPlanDetails,
  getPlanGroupsWithoutCount,
  getReviewAndPlanDetails,
  saveBasicPlanDetails,
  getFieldSchema,
} from "../../../services";
import months from "../../../mocks/months.json";
import ViewAssociatedMEPsTable from "./ViewAssociatedMEPsTable/ViewAssociatedMEPsTable";
import PlanGroupInformation from "./PlanGroupInformation";
import AddToolTip from "../../../components/AddToolTip";
import { DynamicPlanFormFields } from "./DynamicPlanFormFields";

const BasicDetailsContainer = (props) => {
  const { history } = props;
  const { state, dispatch } = useContext(createPlanStore);
  const [isModalOpen, setModalOpen] = useState(false);
  const [showSilder, setShowSlider] = useState(false);
  const [newFlow] = useState("");
  const { planId, flow } = useRouterParams();
  const intPlanId = parseInt(planId);
  const [sidePanelData, setSidePanelData] = useState({});
  const formName = managePlanFormNames.BASIC_DETAILS_MANAGE_PLAN;
  const fields = formFields[formName];
  const [planGroupMappings, setPlanGroupMappings] = useState([]);
  const [savedPlanGroups, setsavedPlanGroups] = useState([]);
  const [initialSavedPlanGroups, setInitialSavedPlanGroups] = useState([]);
  const [planData, setPlanData] = useState({});
  const [fieldSchema, setFieldSchema] = useState([]);

  useDeepEffect(() => {
    getBasicPlanDetails(planId).then((response) => {
      setPlanData(response.plan);
    });
    getFieldSchema("PlanSecondSection").then((res) => {
      setFieldSchema(res?.fieldSchema);
    });
  }, []);
  const { response: planGroupList, loading } = useRequest(
    {
      method: getPlanGroupsWithoutCount,
      defaultResponse: [],
    },
    []
  );
  // useDeepEffect(() => {
  //   getReviewAndPlanDetails(planId).then((response) => {
  //   });
  // }, []);
  useDeepEffect(() => {
    setPlanGroupMappings(
      get(planData, "planGroupMappings", []).map((a) => {
        const planGroup = planGroupList?.find((b) => b.id == a.planGroupId);
        if (planGroup) {
          return {
            ...a,
            name: planGroup.name,
            planGroup: {
              ...planGroup,
            },
          };
        } else {
          return a;
        }
      })
    );
  }, [planData]);
  useDeepEffect(() => {
    setsavedPlanGroups(planGroupMappings);
    setInitialSavedPlanGroups(planGroupMappings);
  }, [planGroupMappings]);

  const headerDetails = getPlanBasicDetailsHeader(planData);
  const buttons = [
    {
      link: ROUTES.PLAN,
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD],
    },
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      link: ROUTES.PLAN,
    },
    {
      label: "Edit",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_PLAN_ROUTES.BASIC_DETAILS,
            pathParam: [FLOW_TYPES.SAVE, intPlanId],
          })
        ),
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.SAVE],
    },
  ];
  const [apiLoading, setApiLoading] = useState(false);

  const getCustomData = (object) => {
    const d = fieldSchema.reduce((acc, field) => {
      acc[field.name] = object[field.name] ?? null;
      return acc;
    }, {});
    return d;
  };

  const onFormSubmit = (values, { setFieldError, setFieldTouched }) => {
    const { history } = props;
    const {
      yearStartMonth,
      yearStartDate,
      yearEndMonth,
      yearEndDate,
      mobilePhoneNumber,
      workPhoneNumber,
      email,
      website,
      name,
      irsPlanNumber,
      trsContractId,
      effectiveDate,
      planTerminationDate,
      shortYearEndDate,
      shortYearStartDate,
      shortYearIndicator,
      mepPlanId,
      sponsoringOrganisationId,
      plan_PlanGroupMappings,
      planAdministrator,
      ...rest
    } = values;
    const startDate = {
      month: yearStartMonth,
      day: yearStartDate,
    };
    const endDate = {
      month: yearEndMonth,
      day: yearEndDate,
    };
    const basicPlanDetails = {
      startDate: startDate,
      endDate: endDate,
      irsPlanNumber: irsPlanNumber,
      trsContractId: trsContractId,
      planTerminationDate: planTerminationDate,
      shortYearIndicator: shortYearIndicator,
      shortYearStartDate: usDateFormat(shortYearStartDate),
      shortYearEndDate: usDateFormat(shortYearEndDate),
    };
    const planAdmin = {
      id: planAdministrator?.id,
      name: name,
      contact: {
        mobilePhoneNumber: mobilePhoneNumber,
        workPhoneNumber: workPhoneNumber,
        email: email,
        website: website,
      },
    };
    const planGroupMappings = savedPlanGroups.map((item) => {
      let savedPlanGroupsMappings = {
        id: item.id == item.planGroupId ? 0 : item.id,
        planId: intPlanId,
        planGroupId: item.planGroupId,
        name: item.name,
      };
      return savedPlanGroupsMappings;
    });
    const customData = JSON.stringify({
      ...customDataArray,
      ...getCustomData(values),
    });
    setApiLoading(true);
    saveBasicPlanDetails(
      omit(
        {
          ...rest,
          basicPlanDetails: basicPlanDetails,
          effectiveDate: effectiveDate,
          planAdministrator: planAdmin,
          mepPlanId: mepPlanId === 0 ? null : mepPlanId,
          sponsoringOrganisationId:
            sponsoringOrganisationId === 0 ? null : sponsoringOrganisationId,
          irsPlanNumber: irsPlanNumber || null,
          trsContractId: trsContractId || null,
          planGroupMappings: synchronizeCollectionPlanGroups(
            planData.planGroupMappings,
            planGroupMappings,
            "id"
          ),
          customData: customData,
        },
        Object.keys(customDataArray)
      )
    ).then((response) => {
      setApiLoading(false);

      if (response.isSuccessful) {
        history.push(
          getPathWithParam({
            path: MANAGE_PLAN_ROUTES.BASIC_DETAILS,
            pathParam: [FLOW_TYPES.EDIT, intPlanId],
          })
        );
        dispatch(
          setManagePlanToastInfo({
            showToast: true,
            toastMessage: "Data saved successfully",
          })
        );
        dispatch(setPageLevelPlanStatus(response.plan));
        dispatch(setPageLevelPlanEffectiveDate(response.plan));
        dispatch(
          setchangeReviewFlag({
            module: "basicDetails",
            review: response.isCompleted,
          })
        );
      } else {
        for (var i = 0; i < response.errorMessages?.length; i++) {
          var _ = response.errorMessages[i];
          setFieldTouched(_.controlName, true);
          setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
        }
      }
    });
  };

  const onViewButtonClick = (data) => {
    setSidePanelData(data);
    setModalOpen(true);
  };
  const createPlanFormValues = get(
    state,
    managePlanFormNames.BASIC_DETAILS_MANAGE_PLAN,
    {}
  );

  let savedPlanGroupNames = isEmpty(savedPlanGroups)
    ? null
    : savedPlanGroups.map((a) => a.name).join(", ");

  const getPlanBasicDetails = (values) => {
    return {
      yearStartMonth: get(values, "basicPlanDetails.startDate.month", 1),
      yearStartDate: get(values, "basicPlanDetails.startDate.day", 1),
      yearEndMonth: get(values, "basicPlanDetails.endDate.month", 12),
      yearEndDate: get(values, "basicPlanDetails.endDate.day", 31),
      irsPlanNumber: get(values, "basicPlanDetails.irsPlanNumber", null),
      trsContractId: get(values, "basicPlanDetails.trsContractId", null),
      // effectiveDate: get(values, "basicPlanDetails.effectiveDate", null),
      planTerminationDate: get(
        values,
        "basicPlanDetails.planTerminationDate",
        null
      ),
      shortYearIndicator: get(
        values,
        "basicPlanDetails.shortYearIndicator",
        false
      ),
      shortYearStartDate: get(
        values,
        "basicPlanDetails.shortYearStartDate",
        null
      ),
      shortYearEndDate: get(values, "basicPlanDetails.shortYearEndDate", null),
    };
  };
  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = newFlow === FLOW_TYPES.SAVE;
  const customDataArray = JSON.parse(planData?.customData ?? "[]");
  return (
    <Formik
      initialValues={{
        ...planData,
        ...getPlanBasicDetails(planData),
        ...getCustomData(customDataArray),
        planName: get(planData, "planName"),
        mobilePhoneNumber: get(
          planData?.planAdministrator?.contact,
          fields.mobilePhoneNumber,
          ""
        ),
        name: get(planData?.planAdministrator, fields.name, ""),
        email: get(planData?.planAdministrator?.contact, fields.email, ""),
      }}
      onSubmit={onFormSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({ handleChange, setFieldValue, handleSubmit, values, ...rest }) => {
        const onDaySelected = (fieldName, value) => {
          setFieldValue(fieldName, value);
        };
        const calculateEndDate = (startMonth, startDate) => {
          startDate =
            startDate > 28
              ? startMonth === 2
                ? 28
                : startDate === 31
                ? startMonth < 8
                  ? startMonth % 2 !== 0
                    ? 31
                    : 30
                  : startMonth % 2 === 0
                  ? 31
                  : 30
                : startDate
              : startDate;
          setFieldValue(fields.yearStartDate, startDate);
          setFieldValue(
            fields.yearEndMonth,
            startDate === 1
              ? startMonth === 1
                ? startMonth + 11
                : startMonth - 1
              : startMonth
          );
          setFieldValue(
            fields.yearEndDate,
            startDate === 1
              ? startMonth <= 8
                ? startMonth % 2 === 0
                  ? 31
                  : startMonth === 3
                  ? 28
                  : startMonth === 1
                  ? 31
                  : 30
                : startMonth % 2 !== 0
                ? 31
                : 30
              : startDate - 1
          );
        };
        return (
          <LoaderWrapper isLoading={!headerDetails || apiLoading}>
            <Form
              autoComplete="off"
              className="h-100"
              onSubmit={handleSubmit}
              validated={!isEmpty(rest.errors)}
            >
              <ManagePlanLayout buttons={buttons} pageFlow={newFlow || flow}>
                {!isEmpty(headerDetails) && [
                  <div className="d-flex">
                    <div className="d-flex basic-plan-details">
                      {headerDetails.map((item) => (
                        <div key={item.label} className="data-item">
                          <div className="label">{item.label}</div>
                          <div className="value" style={{ maxWidth: "150px" }}>
                            {item.label == "Company" ||
                            item.label == "Plan Groups" ||
                            item.label == "Master Plan" ||
                            item.label == "RecordKeeper" ? (
                              <AddToolTip
                                name={
                                  item.label == "Plan Groups"
                                    ? savedPlanGroupNames ?? "-"
                                    : item.value ?? "-"
                                }
                                placement="bottom"
                              ></AddToolTip>
                            ) : (
                              item.value ?? "-"
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="w-50 text-right">
                      {headerDetails.map((item) => (
                        <>
                          {item.value === "Master" ? (
                            <span
                              onClick={onViewButtonClick}
                              className="link-text font-weight-500"
                            >
                              View Associated MEPs/PEPs
                            </span>
                          ) : // : item.value === "Adopting Employer" ? (
                          //   <span
                          //     onClick={onViewButtonClick}
                          //     className="link-text font-weight-500"
                          //   >
                          //     View Master MEPs/PEP
                          //   </span>
                          // )
                          null}
                          <SliderPanel
                            isOpen={isModalOpen}
                            size="50"
                            onClose={() => setModalOpen(false)}
                          >
                            <ViewAssociatedMEPsTable
                              planId={planId}
                              data={sidePanelData}
                            />
                          </SliderPanel>
                        </>
                      ))}
                    </div>
                  </div>,
                ]}
                <br />
                <Field
                  isRequired
                  name={fields.planName}
                  label={"Plan name"}
                  suggestionDefaultText="Suggest a valid name"
                  type="text"
                  placeholder="Plan name"
                  autoComplete="off"
                  value={values[fields.planName]}
                  onChange={handleChange}
                  component={FieldInput}
                  disabled={isEdit && !isSave}
                />
                <Field
                  isRequired
                  name={fields.rkPlanNumber}
                  label={"Plan ID (record keeping plan number)"}
                  placeholder="Plan ID"
                  type="text"
                  autoComplete="none"
                  value={values[fields.rkPlanNumber]}
                  onChange={handleChange}
                  component={FieldInput}
                  noLabelTransform
                  disabled={isEdit && !isSave}
                />

                <Row>
                  <Col md="2">
                    <Field
                      isRequired
                      name={fields.yearStartMonth}
                      label="Plan-Year Start"
                      {...rest}
                      size="sm"
                      placeholder="Month"
                      value={values[fields.yearStartMonth]}
                      options={months.data}
                      disabled={isEdit && !isSave}
                      popupContent={
                        <SearchableList
                          label="Select a month"
                          isNotTypeAhead
                          options={months.data}
                          onSelect={(value) => {
                            setFieldValue(fields.yearStartMonth, value);
                            calculateEndDate(
                              value,
                              values[fields.yearStartDate]
                            );
                          }}
                          selectedValue={values[fields.yearStartMonth]}
                        />
                      }
                      component={FieldDropSide}
                    />
                  </Col>
                  <Col md="2">
                    <Field
                      name={fields.yearStartDate}
                      label=" "
                      {...rest}
                      size="xs"
                      placeholder="Date"
                      value={values[fields.yearStartDate]}
                      disabled={isEdit && !isSave}
                      popupContent={
                        <DayDropdown
                          fromMonthDate={
                            new Date(
                              2019,
                              values[fields.yearStartMonth] - 1 || 0
                            )
                          }
                          onSelect={(value) => {
                            setFieldValue(fields.yearStartDate, value);
                            calculateEndDate(
                              values[fields.yearStartMonth],
                              value
                            );
                          }}
                          value={values[fields.yearStartDate]}
                        />
                      }
                      component={FieldDropSide}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md="2">
                    <Field
                      isRequired
                      name={fields.yearEndMonth}
                      label="Plan-Year End"
                      {...rest}
                      size="sm"
                      placeholder="Month"
                      value={values[fields.yearEndMonth]}
                      options={months.data}
                      autoComplete="on"
                      disabled={true}
                      component={FieldDropSide}
                    />
                  </Col>
                  <Col md="2">
                    <Field
                      name={fields.yearEndDate}
                      label=" "
                      {...rest}
                      size="xs"
                      placeholder="Date"
                      value={values[fields.yearEndDate]}
                      disabled={true}
                      component={FieldDropSide}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md="4">
                    <Field
                      name={fields.effectiveDate}
                      isRequired
                      label="Plan Effective Date"
                      {...rest}
                      value={usDateFormat(values[fields.effectiveDate])}
                      disabled={isEdit && !isSave}
                      isDatePicker
                      onClear={() => setFieldValue(fields.effectiveDate, null)}
                      popupContent={
                        <DatePicker
                          minDate={
                            values.planType == 12 || values.planType == 13
                              ? new Date("01-01-2024")
                              : null
                          }
                          onDayClick={(value) =>
                            onDaySelected(fields.effectiveDate, value)
                          }
                          value={usDateFormat(values[fields.effectiveDate])}
                        />
                      }
                      component={FieldDropSide}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md="4">
                    <Field
                      name={fields.planTerminationDate}
                      label="Plan Termination Date"
                      {...rest}
                      value={usDateFormat(values[fields.planTerminationDate])}
                      disabled={isEdit && !isSave}
                      isDatePicker
                      onClear={() =>
                        setFieldValue(fields.planTerminationDate, null)
                      }
                      popupContent={
                        <DatePicker
                          minDate={
                            values.planType == 12 || values.planType == 13
                              ? new Date("01-01-2024")
                              : null
                          }
                          onDayClick={(value) =>
                            onDaySelected(fields.planTerminationDate, value)
                          }
                          value={usDateFormat(
                            values[fields.planTerminationDate]
                          )}
                        />
                      }
                      component={FieldDropSide}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md="4">
                    <Field
                      isRequired
                      name={fields.shortYearIndicator}
                      label="Is the first year a short-year?"
                      {...rest}
                      size="sm"
                      options={yesNoOptions}
                      selectedValue={values[fields.shortYearIndicator]}
                      onChange={(value) => {
                        setFieldValue(fields.shortYearIndicator, value);
                      }}
                      disabled={isEdit && !isSave}
                      component={FieldButtonGroup}
                    />
                  </Col>
                </Row>
                {values[fields.shortYearIndicator] == true ? (
                  <>
                    <Row>
                      <Col md="4">
                        <Field
                          isRequired
                          name={fields.shortYearStartDate}
                          label="Short-year Start"
                          {...rest}
                          value={usDateFormat(
                            values[fields.shortYearStartDate]
                          )}
                          disabled={isEdit && !isSave}
                          isDatePicker
                          onClear={() =>
                            setFieldValue(fields.shortYearStartDate, null)
                          }
                          popupContent={
                            <DatePicker
                              minDate={
                                values.planType == 12 || values.planType == 13
                                  ? new Date("01-01-2024")
                                  : null
                              }
                              onDayClick={(value) =>
                                onDaySelected(fields.shortYearStartDate, value)
                              }
                              value={usDateFormat(
                                values[fields.shortYearStartDate]
                              )}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col md="4">
                        <Field
                          isRequired
                          name={fields.shortYearEndDate}
                          label="Short-year End"
                          {...rest}
                          value={usDateFormat(values[fields.shortYearEndDate])}
                          disabled={isEdit && !isSave}
                          isDatePicker
                          onClear={() =>
                            setFieldValue(fields.shortYearEndDate, null)
                          }
                          popupContent={
                            <DatePicker
                              minDate={
                                values.planType == 12 || values.planType == 13
                                  ? new Date("01-01-2024")
                                  : null
                              }
                              onDayClick={(value) =>
                                onDaySelected(fields.shortYearEndDate, value)
                              }
                              value={usDateFormat(
                                values[fields.shortYearEndDate]
                              )}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </Col>
                    </Row>
                  </>
                ) : null}
                <div className="line-separator"></div>

                <Row>
                  <Col md="2">
                    <Field
                      label="IRS Plan number"
                      name={fields.irsPlanNumber}
                      {...rest}
                      autoComplete="off"
                      value={values[fields.irsPlanNumber]}
                      onChange={handleChange}
                      noLabelTransform={true}
                      disabled={isEdit && !isSave}
                      className="w-100"
                      component={FieldInput}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Field
                      label="Contract Number"
                      name={fields.trsContractId}
                      {...rest}
                      type="text"
                      autoComplete="off"
                      value={values[fields.trsContractId]}
                      onChange={handleChange}
                      disabled={isEdit && !isSave}
                      component={FieldInput}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md="2">
                    <Field
                      name={fields.indicator316}
                      label="Is this a 3(16)?"
                      {...rest}
                      size="sm"
                      options={yesNoOptions}
                      selectedValue={values[fields.indicator316]}
                      onChange={(value) => {
                        setFieldValue(fields.indicator316, value);
                      }}
                      disabled={isEdit && !isSave}
                      component={FieldButtonGroup}
                    />
                  </Col>
                </Row>
                {fieldSchema && (
                  <DynamicPlanFormFields
                    fieldsSchema={fieldSchema}
                    isEdit={isEdit}
                    isSave={isSave}
                  />
                )}

                <div className="line-separator"></div>

                <p>Plan Administrator</p>

                <Row>
                  <Col>
                    <Field
                      label="Name"
                      name={fields.name}
                      {...rest}
                      type="text"
                      autoComplete="off"
                      value={values[fields.name]}
                      onChange={handleChange}
                      disabled={isEdit && !isSave}
                      component={FieldInput}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Field
                      label="Phone Number"
                      name={fields.mobilePhoneNumber}
                      {...rest}
                      type="text"
                      autoComplete="off"
                      value={getFormattedPhone(
                        values[fields.mobilePhoneNumber]
                      )}
                      onChange={handleChange}
                      disabled={isEdit && !isSave}
                      component={FieldInput}
                      placeholder={FORM_PLACEHOLDERS.phone}
                      maxLength="12"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Field
                      label="E Mail"
                      name={fields.email}
                      {...rest}
                      type="text"
                      autoComplete="off"
                      value={values[fields.email]}
                      onChange={handleChange}
                      disabled={isEdit && !isSave}
                      component={FieldInput}
                    />
                  </Col>
                </Row>

                <>&nbsp;</>

                <p className="font-weight-500 black-33">Plan Group </p>
                <div>
                  <PlanGroupInformation
                    planGroupMappings={planGroupMappings}
                    setPlanGroupMappings={setPlanGroupMappings}
                    initialSavedPlanGroups={initialSavedPlanGroups}
                    setInitialSavedPlanGroups={setInitialSavedPlanGroups}
                    isEdit={isEdit}
                    isSave={isSave}
                    savedPlanGroups={savedPlanGroups}
                    setsavedPlanGroups={setsavedPlanGroups}
                    planGroupList={planGroupList}
                  />
                </div>
              </ManagePlanLayout>
            </Form>
          </LoaderWrapper>
        );
      }}
    </Formik>
  );
};

export default BasicDetailsContainer;
